const DEFAULT_DEV_API_URL = 'http://localhost:7072';

export function getApiBaseUrl() {
  const envUrl = process.env.REACT_APP_API_BASE_URL?.trim();

  if (envUrl)
    return envUrl.replace(/\/+$/, '').replace(/\/api$/, '');

  if (process.env.NODE_ENV === 'development')
    return DEFAULT_DEV_API_URL;

  return '';
}

export function buildApiUrl(path) {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${getApiBaseUrl()}${normalizedPath}`;
}
